import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import data from '../data/products.json';
import './ProductDetail.css';
import '../components/universal.css';

function findProductById(id){
  for(const cat of data.categories){
    const subs = cat.subcategories || [];
    // search subcategories first
    for(const sub of subs){
      const products = sub?.products || [];
      for(const p of products){
        if(p.id===id) return {product:p, category:cat, subcategory:sub};
      }
    }
    // search direct category products (no subcategories)
    const direct = cat.products || [];
    for(const p of direct){
      if(p.id===id) return {product:p, category:cat, subcategory:null};
    }
  }
  return null;
}

export default function ProductDetail(){
  const { id } = useParams();
  const found = findProductById(id);
  useEffect(() => {
    if (!found) return;
    const prev = document.title;
    document.title = `${found.product.name} | HPFS Australia`;
    return () => { document.title = prev; };
  }, [found]);

  if(!found){
    return (
      <main className="container" style={{padding:24}}>
        <h2>Product not found</h2>
        <p><Link to="/products">Back to Products</Link></p>
      </main>
    );
  }

  const { product, category, subcategory } = found;

  const sku = product.sku || 'N/A';
  const specs = product.specs || {};
  const whatsAppNumber = '+919445544888';
  const waText = encodeURIComponent(`Hello, I would like to enquire about ${product.name} (SKU: ${sku}).`);
  const mailto = `mailto:info@example.com?subject=${encodeURIComponent('Product enquiry: '+product.name)}&body=${encodeURIComponent('Hello,%0D%0A%0D%0AI am enquiring about '+product.name+' (SKU: '+sku+').%0D%0A%0D%0ARegards,')}`;

  return (
    <div>
      <div className="product-hero">
        <div className="container">
          <h1>{product.name}</h1>
          <div className="meta">{category.name}{subcategory ? ` / ${subcategory.name}` : ''}</div>
        </div>
      </div>

      <main className="product-detail container">
        <div className="product-row">
          <div className="left-col">
            {product.image && <img src={product.image} alt={product.name} className="product-image" />}
          </div>

          <div className="right-col">
            <h3>Product Details</h3>
            <p>{product.description}</p>

            <ul className="spec-list" aria-label="Product specifications">
              <li><span className="spec-key">SKU</span><span className="spec-val">{sku}</span></li>
              <li><span className="spec-key">Material of Construction</span><span className="spec-val">{specs['Material of Construction'] || 'N/A'}</span></li>
              <li><span className="spec-key">Size</span><span className="spec-val">{specs.Size || 'N/A'}</span></li>
              <li><span className="spec-key">End Connections</span><span className="spec-val">{specs['End Connections'] || 'N/A'}</span></li>
              <li><span className="spec-key">Pressure Rating</span><span className="spec-val">{specs['Pressure Rating'] || 'N/A'}</span></li>
            </ul>

            <div className="action-buttons">
              {/* <a className="uni-btn" href={`https://wa.me/${whatsAppNumber.replace(/[^0-9]/g,'')}?text=${waText}`} target="_blank" rel="noreferrer"><i className="fab fa-whatsapp"></i> WhatsApp Enquiry</a> */}
              <a className="uni-btn" href={mailto}><i className="fas fa-envelope"></i> Send Email</a>
              <Link className='uni-btn' to="/products"><i className="fas fa-arrow-left"></i> Back to Products</Link>
            </div>

            {/* <p style={{marginT/</div>/op:12}}><Link to="/products">Back to Products</Link></p> */}
          </div>
        </div>
      </main>
    </div>
  );
}
